// คำที่ใช้เรียกสิทธิ์ของคนในแบรนด์ — อยู่คนละไฟล์กับ component เพราะไฟล์ที่ export
// ทั้ง component และค่าอื่นทำให้ fast refresh ของ Vite ใช้ไม่ได้
import type { MemberRole } from "../api/settings-api";

/**
 * มีทั้งคำไทยและคำอังกฤษในป้ายเดียว โดยตั้งใจ — คำอังกฤษคือคำที่ทุกคนใช้เรียกกันจริง
 * ส่วนคำไทยบอกว่ามันแปลว่าอะไรสำหรับคนที่เพิ่งเห็นครั้งแรก
 */
export const ROLE_LABEL: Record<MemberRole, string> = {
  viewer: "ผู้ดู (viewer)",
  manage: "ผู้ดูแล (manage)",
};

/**
 * คำเดียวสำหรับ capsule ในการ์ดหน้า Team — ที่นั่นมีคำอธิบายเต็มอยู่ใต้หัวข้อแล้ว
 * ป้ายบนการ์ดจึงเป็นแค่เครื่องหมายบอกระดับ ไม่ใช่ที่อธิบายว่าแต่ละระดับทำอะไรได้
 */
export const ROLE_SHORT: Record<MemberRole, string> = {
  viewer: "viewer",
  manage: "manage",
};
